import _ from 'lodash'
import { createTheme as createMuiTheme } from '@material-ui/core/styles'

let mainColor = '#e014ab'
let fontFamily = 'Lato'

export const theme = createMuiTheme({
  palette: {
    primary: {
      light: mainColor,
      main: mainColor,
      dark: mainColor,
    },
    secondary: {
      light: mainColor,
      main: mainColor,
      dark: mainColor,
    },
  },
  typography: {
    useNextVariants: true,
    fontFamily,
  },
  overrides: {
    MuiInputAdornment: {
      root: {
        zIndex: 2,
      },
    },
    MuiAutocomplete: {
      endAdornment: {
        zIndex: 2,
      },
    },
    MuiChip: {
      root: {
        zIndex: 2,
      },
    },
    MuiPickersToolbarText: {
      toolbarTxt: {
        fontFamily: 'var(--mui-toolbar-font-family)',
        fontSize: 'var(--mui-toolbar-font-size, 3rem)',
        color: 'var(--mui-toolbar-color)',
        fontWeight: 'var(--mui-toolbar-font-weight)',
        fontStyle: 'var(--mui-toolbar-font-style)',
      },
    },
    MuiPickersClock: {
      pin: {
        backgroundColor: 'var(--mui-sel-background-color, var(--mui-primary, var(--ft--primary--color)))',
        background: 'var(--mui-sel-background)',
        backgroundImage: 'var(--mui-sel-background-image)',
        backgroundPosition: 'var(--mui-sel-background-position)',
        backgroundRepeat: 'var(--mui-sel-background-repeat)',
        backgroundSize: 'var(--mui-sel-background-size)',
      },
    },
    MuiPickerDTTabs: {
      tabs: {
        backgroundColor: 'var(--mui-toolbar-background-color, var(--mui-primary, var(--ft--primary--color)))',
        background: 'var(--mui-toolbar-background)',
        backgroundImage: 'var(--mui-toolbar-background-image)',
        backgroundPosition: 'var(--mui-toolbar-background-position)',
        backgroundRepeat: 'var(--mui-toolbar-background-repeat)',
        backgroundSize: 'var(--mui-toolbar-background-size)',
        '& button': {
          fontFamily: 'var(--mui-toolbar-font-family)',
          fontSize: 'var(--mui-toolbar-font-size, 1rem)',
          color: 'var(--mui-toolbar-color)',
          fontWeight: 'var(--mui-toolbar-font-weight)',
          fontStyle: 'var(--mui-toolbar-font-style)',
        },
      },
    },
    MuiPickersClockPointer: {
      thumb: {
        backgroundColor: 'var(--mui-sel-background-color, var(--mui-primary, var(--ft--primary--color))) !important',
        border: '14px solid var(--mui-sel-background-color, var(--mui-primary, var(--ft--primary--color)))',
        background: 'var(--mui-sel-background)',
        backgroundImage: 'var(--mui-sel-background-image)',
        backgroundPosition: 'var(--mui-sel-background-position)',
        backgroundRepeat: 'var(--mui-sel-background-repeat)',
        backgroundSize: 'var(--mui-sel-background-size)',
      },
      pointer: {
        backgroundColor: 'var(--mui-sel-background-color, var(--mui-primary, var(--ft--primary--color)))',
        background: 'var(--mui-sel-background)',
        backgroundImage: 'var(--mui-sel-background-image)',
        backgroundPosition: 'var(--mui-sel-background-position)',
        backgroundRepeat: 'var(--mui-sel-background-repeat)',
        backgroundSize: 'var(--mui-sel-background-size)',
      },
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: 'var(--mui-toolbar-background-color, var(--mui-primary, var(--ft--primary--color)))',
        background: 'var(--mui-toolbar-background)',
        backgroundImage: 'var(--mui-toolbar-background-image)',
        backgroundPosition: 'var(--mui-toolbar-background-position)',
        backgroundRepeat: 'var(--mui-toolbar-background-repeat)',
        backgroundSize: 'var(--mui-toolbar-background-size)',
        borderWidth: 'var(--mui-toolbar-border-width)',
        borderStyle: 'var(--mui-toolbar-border-style)',
        borderColor: 'var(--mui-toolbar-border-color)',
        borderRadius: 'var(--mui-toolbar-border-radius)',
        ..._.reduce(
          ['Top', 'Left', 'Right', 'Bottom'],
          (ret, key) => ({
            ...ret,
            [`border${key}Style`]: `var(--mui-toolbar-border-${_.lowerCase(key)}-style, var(--mui-toolbar-border-style))`,
            [`border${key}Color`]: `var(--mui-toolbar-border-${_.lowerCase(key)}-color, var(--mui-toolbar-border-color))`,
            [`border${key}Radius`]: `var(--mui-toolbar-border-${_.lowerCase(key)}-radius, var(--mui-toolbar-border-width))`,
          }),
          {}
        ),
        '& button h6': {
          fontFamily: 'var(--mui-toolbar-font-family)',
          fontSize: 'var(--mui-toolbar-font-size, 1rem)',
          color: 'var(--mui-toolbar-color)',
          fontWeight: 'var(--mui-toolbar-font-weight)',
          fontStyle: 'var(--mui-toolbar-font-style)',
        },
        '& button h4': {
          fontFamily: 'var(--mui-toolbar-font-family)',
          fontSize: 'var(--mui-toolbar-font-size, 2.125rem)',
          color: 'var(--mui-toolbar-color)',
          fontWeight: 'var(--mui-toolbar-font-weight)',
          fontStyle: 'var(--mui-toolbar-font-style)',
        },
      },
    },
    MuiPickersDay: {
      daySelected: {
        backgroundColor: 'var(--mui-sel-background-color, var(--mui-primary, var(--ft--primary--color)))',
        background: 'var(--mui-sel-background)',
        backgroundImage: 'var(--mui-sel-background-image)',
        backgroundPosition: 'var(--mui-sel-background-position)',
        backgroundRepeat: 'var(--mui-sel-background-repeat)',
        backgroundSize: 'var(--mui-sel-background-size)',
        '& p': {
          fontFamily: 'var(--mui-sel-font-family)',
          fontSize: 'var(--mui-sel-font-size, 0.875rem)',
          color: 'var(--mui-sel-color)',
          fontWeight: 'var(--mui-sel-font-weight)',
          fontStyle: 'var(--mui-sel-font-style)',
        },
        '&:hover': {
          backgroundColor: 'var(--mui-sel-background-color, var(--mui-primary, var(--ft--primary--color)))',
          background: 'var(--mui-sel-background)',
          backgroundImage: 'var(--mui-sel-background-image)',
          backgroundPosition: 'var(--mui-sel-background-position)',
          backgroundRepeat: 'var(--mui-sel-background-repeat)',
          backgroundSize: 'var(--mui-sel-background-size)',
        },
      },
    },
    MuiTypography: {
      root: {
        fontFamily,
      },
    },
    MuiInputBase: {
      input: {
        fontSize: 16,
        fontWeight: 400,
        fontFamily: 'inherit',
        color: '#333333',
        '&.ft--form--input': {
          height: 46,
        },
        '&:-webkit-autofill': {
          transitionDelay: '9999s',
          transitionProperty: 'background-color, color',
        },
      },
    },
    MuiButtonBase: {
      root: {
        fontSize: 16,
        fontWeight: 400,
        fontFamily: 'inherit',
        color: '#333333',
      },
    },
    MuiButton: {
      root: {
        fontSize: 16,
        fontWeight: 400,
        fontFamily: 'inherit',
        color: '#333333',
        '&:focus-within': {
          outline: 'var(--titan-focus-outline)',
          boxShadow: 'var(--focus-shadow)',
        },
      },
    },
  },
})

export const themeRTL = createMuiTheme({
  palette: {
    primary: {
      light: mainColor,
      main: mainColor,
      dark: mainColor,
    },
    secondary: {
      light: mainColor,
      main: mainColor,
      dark: mainColor,
    },
  },
  typography: {
    useNextVariants: true,
  },
  direction: 'rtl',
  overrides: {
    MuiInputAdornment: {
      root: {
        zIndex: 2,
      },
    },
    MuiAutocomplete: {
      endAdornment: {
        zIndex: 2,
      },
    },
    MuiChip: {
      root: {
        zIndex: 2,
      },
    },
    MuiTypography: {
      root: {
        fontFamily,
      },
    },
    MuiInputBase: {
      input: {
        fontSize: 16,
        fontWeight: 400,
        fontFamily: 'inherit',
        color: '#333333',
        '&.ft--form--input': {
          height: 46,
        },
        '&:-webkit-autofill': {
          transitionDelay: '9999s',
          transitionProperty: 'background-color, color',
        },
      },
    },
    MuiButtonBase: {
      root: {
        fontSize: 16,
        fontWeight: 400,
        fontFamily: 'inherit',
        color: '#333333',
      },
    },
  },
  MuiButton: {
    root: {
      fontSize: 16,
      fontWeight: 400,
      fontFamily: 'inherit',
      color: '#333333',
      '&:focus-within': {
        outline: 'var(--titan-focus-outline)',
        boxShadow: 'var(--focus-shadow)',
      },
    },
  },
})
